import React from 'react';
import { focusRing, styled, createSubcomponent } from '@workday/canvas-kit-react/common';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
import { usePillModel } from './usePillModel';
import { xSmallIcon } from '@workday/canvas-system-icons-web';
import { colors, space } from '@workday/canvas-kit-react/tokens';
import { BaseButton } from '@workday/canvas-kit-react/button';
const getIconColors = () => {
    return {
        default: {
            icon: colors.licorice200,
        },
        hover: {
            icon: colors.licorice500,
        },
        active: {
            icon: colors.licorice500,
        },
        focus: {
            icon: colors.licorice500,
            focusRing: focusRing({
                innerColor: 'transparent',
            }),
        },
        disabled: {
            icon: colors.licorice100,
            opacity: '1',
        },
    };
};
const StyledIconButton = styled(BaseButton)({
    marginInlineEnd: '-7px',
    marginInlineStart: `-2px`,
    overflow: 'visible',
    '::after': {
        content: '""',
        height: space.l,
        width: space.l,
        position: 'absolute',
        left: '-7px',
        bottom: '-7px',
        margin: 0,
        pointerEvents: 'all',
        cursor: 'pointer',
    },
});
export const PillIconButton = createSubcomponent('button')({
    modelHook: usePillModel,
})(({ size, icon = xSmallIcon, maxWidth, children, 'aria-label': ariaLabel = 'remove', ...elemProps }, Element, model) => {
    return (React.createElement(StyledIconButton, Object.assign({ borderRadius: "s", height: 20, width: 20, padding: "zero", disabled: model.state.disabled, colors: getIconColors(), "aria-labelledby": `removable-${model.state.id} label-${model.state.id}`, as: Element, position: "relative" }, elemProps),
        React.createElement(SystemIcon, { "aria-label": ariaLabel, id: `removable-${model.state.id}`, icon: icon, size: space.m, "aria-hidden": true, role: "img" })));
});
